<div class="header_second">
    <div class="Dashboard_head ">Gallery
        <button mat-raised-button style="background-color:#dd484b; 
                color:#fff;                                       
                font-size: 12px;
                margin-right: 15px;" (click)="openDialog()">Add Gallery</button>
    </div>
</div>


<div class="mat-elevation-z8 m-1">
    <mat-form-field appearance="fill" style="display: flex;" subscriptSizing="dynamic">
        <!-- <mat-label>Search</mat-label> -->
        <input matInput type="text" name="table_search" (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>

    <div class="table-responsive">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box"
            [fullScreen]="false">
            <p style="color: white"> Loading... </p>
        </ngx-spinner>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="gallery_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sr.No </th>
                <td mat-cell *matCellDef="let element"> {{element.gallery_id}} </td>
            </ng-container>

            <ng-container matColumnDef="image_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let element"><img
                        src="https://aieventzo.com/upload/{{event_id}}/gallery/{{element.image_name}}"
                        onerror="this.onerror=null; this.src='https://aieventzo.com/upload/default.png';"
                        style="width: 50px;height: 50px;padding: 2px 0px;border-radius: 10px;">
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Title </th>
                <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <!-- <th mat-header-cell *matHeaderCellDef > Action </th> -->
                <td mat-cell *matCellDef="let element" style="white-space: nowrap;">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-left: 5px;"
                        (click)="openEditDialog(element.gallery_id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>
                    <button mat-raised-button color="warn" matTooltip="Delete" style="margin-left: 5px;"
                        (click)="deleteGallery(element.gallery_id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-paginator [showFirstLastButtons]="true" [length]="100" [pageSize]="100" [pageSizeOptions]="[150, 200, 250]"
        aria-label="Select page">
    </mat-paginator>
</div>